import Banner from 'components/Banner';
import React from 'react';
import { useTranslation } from 'services/localization';

export const NoDepositSupportBanner = () => {
	const { t } = useTranslation();
	const noDepositMethodsWarning = {
		title: t(
			'account.payments.methodsDontSupportDeposit',
			"Selected payment methods don't support deposits",
		),
		description: t(
			'account.payments.methodsDontSupportDepositInfo',
			'Products with a security deposit are not available in your online store. Please enable Card payments from Rentle payments or Pay on pickup.',
		),
	};

	return (
		<Banner
			variant="info"
			title={noDepositMethodsWarning.title}
			description={noDepositMethodsWarning.description}
		/>
	);
};
